module.exports = __webpack_public_path__ + "assets/e2af25cc978f3c29a2580c4373c0bdd0.svg";